import { OrderingInitialState, SelectMenuItemAction } from '@reducers/ordering/types';

export const selectMenuItem = (state: OrderingInitialState, action: SelectMenuItemAction): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    selectedMenuItem: action.payload.selectedMenuItem,
    isMenuItemDetailsVisible: true,
  },
});
